module.exports = __webpack_public_path__ + "images/7e41bc7d2b6cae25206deae49ce76964.svg";